import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import Loader from '../../../components/loader';
import Input from '../../../components/elements/form/input';
import Button from '../../../components/elements/button';
import { useUserApi } from '../../../store/api/hooks/userApiHook';
import toast from 'react-hot-toast';

interface CreateUserTypeFormProps {
    UserTypeID?: any;
    onCreate?: () => void;
    onCancel?: () => void;
}

const CreateUserType: React.FC<CreateUserTypeFormProps> = ({ UserTypeID = null, onCreate = () => { }, onCancel = () => { } }) => {
    const { control, register, handleSubmit, formState: { errors }, watch, getValues, setValue } = useForm<any>();
    const [showLoader, setShowLoader] = React.useState<boolean>(false);
    const userApi = useUserApi();
    const [editData, setEditData] = useState<any>(null);

    var onSubmit = async (data: any) => {
        const payload = {
            name: data.name,
            isSystemDefined: false,
            isVisible: true,
            isActive: 1,
            isDeleted: 0,
            ...(UserTypeID ? { userTypeID: UserTypeID } : {})
        };
        setShowLoader(true);
        try {
            const response: any = await new Promise((resolve, reject) => {
                userApi.saveUserType(payload, resolve, reject);
            });
            setShowLoader(false);

            if (response?.successful) {
                toast.success(response?.message || 'User type has been saved successfully');
                onCreate();
            } else {
                toast.error(response?.message || 'Failed to save user type, please try again');
            }
        } catch (error) {
            setShowLoader(false);
            toast.error('Network error, unable to save user type');
        }
    };



    const initPage = async () => {
        setShowLoader(true);
        if (UserTypeID) {
            const usertyperesp: any = await new Promise((resolve, reject) => {
                userApi.getUserTypeByID({ userTypeID: UserTypeID }, resolve, reject);
            }).catch((err) => {
                return null;
            });
            if (usertyperesp?.successful === true) {
                setValue('name', usertyperesp.userType.name);
                setEditData(usertyperesp.userType);
                
            }
            console.log('User Type Resp:', usertyperesp);
        }
         setShowLoader(false);
    }

    useEffect(() => {
        initPage();

    }, []);


    return (
        <div className={`relative h-full flex flex-col`}>
            {showLoader && (
                <div className={`absolute p-8 w-full h-full z-[2px] bg-white bg-opacity-30`}>
                    <Loader />
                </div>
            )}
            <form onSubmit={handleSubmit(onSubmit)} className={`${showLoader ? `hidden` : `flex flex-col h-full`}`} noValidate>
                <div className="flex-1 overflow-auto">
                <div className={`pt-4`}>
                    <Controller
                        name={`name`}
                        control={control}
                        rules={{ required: `User Type Name is required` }}
                        render={({ field: { value, onChange } }) => (
                            <Input
                                label={`User Type Name`}
                                type='text'
                                value={value}
                                onChange={onChange}
                                required={true}
                                error={errors.UserTypeName?.message as any}
                                placeholder='Enter User Type Name'
                            />
                        )}
                    />

                </div>
                </div>
                <div className={`flex justify-end gap-2 flex-shrink-0 pt-4 border-t border-gray-200 mt-6`}>
                    <Button type='button' theme='secondary' onClick={() => {
                        onCancel();
                    }}>
                        Cancel
                    </Button>
                    <Button type='submit'>{UserTypeID ? 'Update' : 'Save'}</Button>
                </div>
            </form>
        </div>
    );
};

export default CreateUserType;
